import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Card, Tooltip, Button } from 'antd'
import { PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'

class ObjectCourseDetails extends Component {

    state = {
        loading: false,
        deviceWidth: 0,
        userLevel: 'NORMAL',
        item: {},
        // 分頁參數
        items: [],
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'NONE',
        searchValue: '',
        filterStatus: '',

        domnloadFile: '',
        isShowModal: false
    }

    UNSAFE_componentWillMount() {
        window.removeEventListener("resize", this.resize.bind(this));

        this.init_columns()
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        this.api_page_items(1)
    }

    resize() {
        this.setState({deviceWidth: window.innerWidth});
    }


    // 遠端數據處理 //////////////////////////////////////////////
    api_page_items = async (current) => {

    }

    // 數據配置設定 ////////////////////////////////////////////// 
    init_columns = () => {
        this.columns = [
        ]
    }

    // 操作互動處理 //////////////////////////////////////////////   
    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)
                });
            }
        } else {
            this.api_page_items(pagination.current)
        }
    }

    handle_data_refresh = () => {
        this.api_page_items(this.current)
    }

    /////////////////////////////////////////////////////////////     
    render() {
        const title = (
            <>
                <span>
                    <Tooltip placement="top" title="重新整理"><Button type='primary' onClick={() => this.handle_data_refresh()}><i className="fas fa-sync-alt"></i></Button></Tooltip>
                    {' '}
                </span>
            </>
        )
        return (
            <Card title={title}>

            </Card>
        )

    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(ObjectCourseDetails)